export default __webpack_public_path__ + "static/media/print.ae1438dc.svg";